// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hxMdk{width:100%}.kBpYi{width:100%;min-width:160px}.fHGf9{padding:8px 0;min-width:200px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `hxMdk`,
	"option": `kBpYi`,
	"optionList": `fHGf9`
};
export default ___CSS_LOADER_EXPORT___;
